import { useRequesterStore } from '../stores/requester'
let requesterX: any

export async function createReminder(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/reminder/create`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}
export async function getAllReminders() {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/reminder`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function deleteReminder(id: number) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Delete({
      route: `/reminder/delete/${id}`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function getNotifications() {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/reminder/notifications`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}
